import React from "react";
import { TimePicker } from "antd";

const TimeArrival = ({ index, values, handleChange }) => {
  return (
    // <TimePicker
    //   className="form-control"
    //   style={{
    //     width: "98%",
    //     borderRadius: "4px",
    //     // border:
    //     //   touched.flightLegs &&
    //     //   touched.flightLegs[index].arrivalTime &&
    //     //   !timeArrival[index].time &&
    //     //   "1px solid red",
    //   }}
    //   id={`flightLegs.return[${index}]arrivalTime`}
    //   name={`flightLegs.return[${index}]arrivalTime`}
    //   use24Hours
    //   value={timeArrival[index]?.time}
    //   onChange={(time, timeString) =>
    //     changeTimeArrivalInput(time, timeString, index)
    //   }
    //   required
    // />
    <>
      <input
        placeholder="hh:mm"
        type="time"
        className="form-control" // name="arrivalTime"
        id={`flightLegs.return[${index}].arrivalTime`}
        name={`flightLegs.return[${index}].arrivalTime`}
        // display="Request Date"
        // onBlur={handleBlur}
        value={values?.flightLegs?.return[index]?.arrivalTime}
        onChange={handleChange}
        // touched={touched?.flightLegs?.return[index]?.arrivalTime}
      />
    </>
  );
};

export default TimeArrival;
